import Vue from 'vue'
import Vuex from 'vuex'
import app from './app';
import indexTable from "./indexTable";
import loginPage from "./loginPage";

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        app,
        indexTable,
        loginPage
    },
    strict: false,
})
